import { Button, Paper } from "@mui/material";
import { useForm } from "react-hook-form";
import { useContext, useEffect, } from "react";
import { CustomFormField } from "../../../../../utilis/component/CustomFormElement";
import { PaymentContext, PaymentContextType } from "../context/Listprovider";
import { PayModel } from "../../type";
// import debounce from "../../../../utilis/methods/networkHandling";
import { FormOnChangeEventType } from "../../../../../EMR/types";
import useAuthentication from "@hooks/useAuthentication";

const AddPayment = () => {
  const { user } = useAuthentication()
  const { control, handleSubmit, reset, getValues,
    // setValue 
  } = useForm({
    mode: "onChange"
  });
  const { edit, amountDetails, list, setList, setBalance, balance, } = useContext(PaymentContext) as PaymentContextType;


  const AddPayment = (data: any) => {
    const details = {
      patientMasterID: amountDetails.patientMasterID,
      encounterID: amountDetails.encounterId,
      paymentType: data.type.id,
      receivedAmount: data?.ReceivedAmount ? parseFloat(data?.ReceivedAmount)?.toFixed(2) : 0,
      balanceAmount: data?.Balance ? parseFloat(data?.Balance)?.toFixed(2) : 0,
      amount: data?.Amount ? parseFloat(data?.Amount)?.toFixed(2) : 0,
      discount: (parseFloat(data?.Discount) || 0).toFixed(2),
      netAmount: data?.netAmount ? parseFloat(data?.netAmount)?.toFixed(2) : 0,
      createdById: Number(user?.login_id)
    }
    setList((prev: PayModel[]) => ([...prev, details]))
    
    if (data.Balance == 0) {
      setBalance(0);
    }
    
    reset({
      ...getValues(),
      type: null,
      ReceivedAmount: 0,
      Discount: 0,
      Amount: details.balanceAmount
    })
  }

  const clearList = () => {
    setList([])
    const share = Number(amountDetails?.patShare || 0);
    reset({
      Amount: share.toFixed(2),
      netAmount: share.toFixed(2),
      Balance: share.toFixed(2)
    });
    setBalance(share)
  }

  useEffect(() => {
    const share = Number(amountDetails?.patShare || 0);
    reset({
      Amount: share.toFixed(2),
      netAmount: share.toFixed(2),
      Balance: share.toFixed(2)
    });
  }, [amountDetails])

  const handleClose = () => {
    const currentValues = getValues();
    let Balance = Boolean(list.length) ? list[list.length - 1].balanceAmount : currentValues.netAmount;
    const numericBalance = Number(Balance || 0).toFixed(2);
    reset({
      ...currentValues,
      type: null,
      Balance: numericBalance,
      Amount: numericBalance,
      ReceivedAmount: null,
      Discount: null
    });
  };

  useEffect(() => {
    if (edit) {
      handleClose()
      const currentBalance = Number(getValues("Balance") || 0);
      const newBalance = edit.discount
        ? currentBalance + Number(edit.receivedAmount || 0) + Number(edit.discount || 0)
        : currentBalance + Number(edit.receivedAmount || 0);
      reset({
        Amount: Number(newBalance || 0).toFixed(2),
        Balance: Number(newBalance || 0).toFixed(2),
        netAmount: Number(edit.netAmount || 0).toFixed(2)
      });
      setBalance(newBalance);
      const updatedList = list.filter(item => item !== edit);
      setList(updatedList);
    }
  }, [edit]);

  const handleDiscountChange = (params: FormOnChangeEventType) => {
    let { target } = params
    const allData = getValues()
    let Amount = 0
    if (Boolean(list.length)) {
      const latestEntry = list[list.length - 1]
      Amount = parseFloat(allData.netAmount) - latestEntry.balanceAmount
      Amount = latestEntry.balanceAmount - parseFloat(target.value || "0")
    } else {
      Amount = parseFloat(allData.netAmount) - parseFloat(target.value || "0")
    }

    reset({
      ...allData,
      Amount: Amount.toFixed(2),
      Balance: Amount.toFixed(2),
      ReceivedAmount: null
    })
  }

  const handleReceivedAmountChange = (params: FormOnChangeEventType) => {
    const { target } = params
    const allData = getValues()
    const Amount = parseFloat(allData.Amount || "0");
    const ReceivedAmount = parseFloat(target.value || "0");
    reset({
      ...allData,
      Balance: (Amount - ReceivedAmount).toFixed(2)
    })
  }



  return (
    <div className="border-2 rounded">
      <form onSubmit={handleSubmit(AddPayment)}>
        <Paper className="grid grid-cols-12 p-4 gap-2">
          <div className="col-span-3">
            <CustomFormField
              control={control}
              element="autocomplete"
              options={[{ id: 1, name: "cash" }, { id: 0, name: "card" }, { id: 2, name: "wallet" }]}
              name="type"
              rules={{ required: "Payment Type is Required" }}
              fieldProps={{ label: "Payment Type" }}
              autocompleteProps={{
                getOptionLabel: (item: { id: number, name: string }) => (item.name),
                isOptionEqualToValue: (item: any, value: any) => (item.id == value.id)
              }}
            />
          </div>


          <div className="col-span-3">
            <CustomFormField
              control={control}
              element="input"
              name="netAmount"
              rules={{ required: "Net Amount is Required" }}
              fieldProps={{ label: "Net Amount", type: "number", InputProps: { readOnly: true } }}
            />
          </div>

          <div className="col-span-3">
            <CustomFormField
              control={control}
              element="input"
              name="Discount"
              rules={{
                required: false, onChange: handleDiscountChange, min: { value: 0, message: "Amount must be at least 0" }
                , validate: (value) => {
                  const discount = parseFloat(value) || 0;
                  return (
                    discount <= getValues("netAmount") ||
                    `discount  Amount must be less than or equal to amount (${getValues("netAmount")})`
                  );
                }
              }}
              fieldProps={{ label: "Discount", type: "number" }}
            />
          </div>
          <div className="col-span-3">
            <CustomFormField
              control={control}
              element="input"
              name="Amount"
              rules={{ required: "Amount is required", min: { value: 0, message: "Amount must be at least 0" } }}
              fieldProps={{ label: "Amount", type: "number", InputProps: { readOnly: true } }}
            />
          </div>
          <div className="col-span-3">
            <CustomFormField
              control={control}
              element="input"
              name="ReceivedAmount"
              rules={{
                validate: (value) => {
                  if (value === null || value === undefined || value === "") {
                    return "Received Amount is Required";
                  }

                  const receivedAmount = parseFloat(value);

                  if (receivedAmount < 0) {
                    return "Amount must be at least 0";
                  }

                  if (receivedAmount > parseFloat(getValues("Amount") || "0")) {
                    return `Received Amount must be less than or equal to Amount (${getValues("Amount")})`;
                  }

                  return true;
                },
                onChange: handleReceivedAmountChange
              }}
              fieldProps={{ label: "Recieved Amount", type: "number" }}
            />
          </div>

          <div className="col-span-3">
            <CustomFormField
              control={control}
              element="input"
              name="Balance"
              rules={{ required: false, min: { value: 0, message: "balance must be at least 0" } }}
              fieldProps={{ label: "Balance Amount", type: "number", InputProps: { readOnly: true } }}
            />
          </div>
          <div className={`col-span-3 flex items-center gap-x-3 justify-center`}>
            <>
              <Button disabled={getValues("ReceivedAmount") < 0} type="submit" color="primary">
                Add Payment
              </Button>
              <Button disabled={balance == 0} onClick={() => handleClose()} color="error">
                Clear
              </Button>
              <Button onClick={() => clearList()} color="error">
                reset
              </Button>

            </>

          </div>
        </Paper>
      </form>
    </div>
  );
};

export default AddPayment;


